/**
 * Context that will contain most values that need to be passed and used along the chart render tree.
 */

import React, { useContext } from 'react';

export type ChartContextValue = {
    chartKey: number;
    queryDimensions: QueryDimensionT[];
    queryFilters: QueryFilterT[];
    queryMetrics: QueryMetricT[];
    publicToken: string | undefined;
    isChartViewedOnDashboard: boolean;
    disableDashboardFilters: boolean;
    isUpdateChartLoading: boolean;
};

const initialContext: ChartContextValue = {
    chartKey: 0,
    queryDimensions: [],
    queryFilters: [],
    queryMetrics: [],
    publicToken: undefined,
    isChartViewedOnDashboard: false,
    disableDashboardFilters: false,
    isUpdateChartLoading: false,
};

const ChartContext = React.createContext<ChartContextValue>({
    ...initialContext,
});
const useChartContext = () => useContext(ChartContext);

export { useChartContext, ChartContext };
